import StudentQuizzes from "layouts/StudentQuizzes";
import QuizByCode from "layouts/QuizByCode";
import Titles from "layouts/titles";
import ShowTile from "layouts/titles/ShowTile";
import ShowThreeD from "layouts/titles/ShowThreeD";
import ShowQuestions from "layouts/quizTitles/ShowQuestions";
import AIHistory from "layouts/AIHistory";
import Icon from "@mui/material/Icon";

const studentRoutes = [
  {
    type: "collapse",
    name: "Histology",
    key: "histology",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/histology",
    component: <Titles type="his" readOnly />,
  },
  {
    type: "collapse",
    name: "Embryology",
    key: "embryology",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/embryologyTitles",
    component: <Titles type="emb" readOnly />,
  },
  {
    type: "collapse",
    name: "3D Models",
    key: "threeD",
    icon: <Icon fontSize="small">view_in_ar</Icon>,
    route: "/threeDTitles",
    component: <Titles type="three_d_model" readOnly />,
  },
  {
    type: "collapse",
    name: "My Quizzes",
    key: "my-quizzes",
    icon: <Icon fontSize="small">quiz</Icon>,
    route: "/my-quizzes",
    component: <StudentQuizzes />,
  },
  {
    type: "collapse",
    name: "Mock Quiz",
    key: "mock-quiz",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/mock-quiz",
    component: <QuizByCode />,
  },
  {
    type: "collapse",
    name: "AI History",
    key: "ai-history",
    icon: <Icon fontSize="small">auto_awesome</Icon>,
    route: "/ai-history",
    component: <AIHistory />,
  },
  {
    name: "quiz-by-code",
    key: "quiz-by-code",
    route: "/quiz-by-code",
    component: <QuizByCode />,
  },
  {
    name: "showTitle",
    key: "showTitle",
    route: "/showTitle/:id/:lang",
    component: <ShowTile />,
  },
  {
    name: "showThreeD",
    key: "showThreeD",
    route: "/showThreeD/:id/:lang",
    component: <ShowThreeD />,
  },
  {
    name: "showQuestions",
    key: "showQuestions",
    route: "/showQuestions/:id/:lang",
    component: <ShowQuestions />,
  },
];

export default studentRoutes;
